import "./Loader.css";

const Loader = () => {
  return (
    <div className="loading">
      <div className="div div-1"></div>
      <div className="div div-2"></div>
      <div className="div div-3"></div>
      <div className="div div-4"></div>
      <div className="div div-5"></div>
    </div>
  );
};

export default Loader;
